import Styles from './PostPreviewModal.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { DesignChannel } from 'components/NewFileModal/Types'
import { Button } from 'blaze-ui/Button'
import { Calendar2 } from 'blaze-ui/icons'
import dayjs from 'dayjs'
import { IntegrationPicker } from './IntegrationPicker'
import { TikTokPostSettings } from './components/TikTokPostSettings'
import { usePostPreviewContext } from './PostPreviewContext'
import { PostOptionsPage } from './Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Text } from 'blaze-ui/Text/Text'
import { PostDetailsButtons } from './PostDetailsButtons'
import { YoutubePostDetails } from './components/Youtube/YoutubePostDetails'

interface Props {
  fileId: string
  channel: DesignChannel
}

export const PostDetails = ({ fileId, channel }: Props) => {
  const { scheduledPost, provider, providerName, setPage, dateTime, isPostable } = usePostPreviewContext()

  if (!scheduledPost || !provider || !providerName) return null

  return (
    <div className={Styles.integrationContainer}>
      <Heading level={4}>Blaze will post the content for you on {providerName}.</Heading>
      <div className={Styles.postDetails}>
        <IntegrationPicker scheduledPost={scheduledPost} providerName={providerName} provider={provider} />
        <div className={Styles.section}>
          <Text variant="label" color="var(--dark-60)">
            Post time
          </Text>
          <div className={Styles.postTime}>
            <Calendar2 />
            <Text variant="label" color="var(--dark-60)">
              {dateTime ? dayjs(dateTime).format('ddd, MMM D h:mma z') : 'Not scheduled'}
            </Text>
            {dateTime && (
              <Button
                size="sm"
                variant="ghost"
                isDisabled={!isPostable}
                onPress={() => {
                  setPage(PostOptionsPage.Schedule)
                }}
              >
                Edit
              </Button>
            )}
          </div>
        </div>
      </div>
      {provider === ExternalIntegrationEnum.TikTok && (
        <TikTokPostSettings scheduledPost={scheduledPost} channel={channel} />
      )}
      {provider === ExternalIntegrationEnum.YouTube && (
        <YoutubePostDetails fileId={fileId} channel={channel} scheduledPost={scheduledPost} />
      )}
      <ResponsiveDesign.Desktop>
        <PostDetailsButtons fileId={fileId} channel={channel} />
      </ResponsiveDesign.Desktop>
    </div>
  )
}
